// Win-back, 1 week after a lapse. MARKETING — pass `unsubscribeUrl` (PECR).

import type { EmailData } from "../../types";
import { b, body, call, esc, p } from "../../layouts/chrome";
import { callCta, plainEmailHtml } from "../../layouts/plain";
import { brand } from "../brand";

export const subject = (_data: EmailData) => `A week without cover? Come back to ${brand.name} — £25 voucher`;

export const html = (data: EmailData) =>
  plainEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    heading: "Is your business still covered?",
    cta: callCta(brand.callNumber),
    unsubscribeUrl: data.unsubscribeUrl,
    bodyHtml: body(
      p(
        `It's been a week since your policy for ${b(`'${esc(data.companyName)}'`)} lapsed — which may mean your business is currently ${b("unprotected")}.`,
      ),
      p(
        `One incident without cover can cost far more than a year's premium. Rejoin ${brand.name} and we'll send you a ${b("£25 Amazon voucher")} when your new policy starts.`,
      ),
      p(`Call ${call(brand)} — it takes minutes to get covered again.`),
      p(
        "£25 Amazon voucher: one per business, issued after your new policy has been active for 30 days. Ask our team for full terms.",
      ),
    ),
  });
